import { useNavigate } from "react-router-dom";
import { IoArrowBack } from "react-icons/io5";
import useScrollDetection from "../hooks/useScrollDetection";

const BlankPage = () => {
  const navigate = useNavigate();
  const isScrolled = useScrollDetection(5);

  return (
    <div className="bg-white relative">
      <div className="flex flex-row justify-center h-screen">
        <div className="w-full lg:w-1/2 flex justify-center lg:items-center px-0 lg:px-12 text-base">
          <div className="rounded-md p-4 lg:p-8 w-full h-fit">
            <div
              className={`bg-white fixed z-[9999] top-0 left-0 px-4 py-3 w-full flex flex-col items-center transition-all duration-300 ${
                isScrolled ? "shadow-md rounded-b-3xl" : ""
              }`}
            >
              <div className="flex flex-col w-full gap-4">
                <div className="w-full flex items-center gap-2 lg:hidden text-xl">
                  <div
                    onClick={() => navigate(-1)}
                    className="p-1 hover:bg-gray-200 rounded-full"
                  >
                    <IoArrowBack className="text-gray-500" size={20} />
                  </div>
                  <p className="font-semibold text-slate-700">Blank Page</p>
                </div>
              </div>
            </div>

            <div className="py-12">
              <div className="mb-4">
                <h1 className="font-semibold text-lg mb-1 text-slate-700">
                  Kamu berada di halaman yang salah!
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlankPage;
